import React, { useEffect, useState } from "react"
import { Download, Loader2 } from "lucide-react"
import { Button } from "src/components/ui/button"
import { useToast } from "src/components/ui/toast"
import { useAgingReport } from "src/features/collections/hooks/useAgingReport"
import { agingExportUrl } from "src/features/collections/api/collectionsApi"
import AgingBucketChart from "src/features/collections/components/AgingBucketChart"
import AgingTable from "src/features/collections/components/AgingTable"
import ProjectFilter from "src/features/collections/components/ProjectFilter"

export default function AgingReportPage() {
  const { toast } = useToast()
  const [projectId, setProjectId] = useState("")
  const { data, loading, fetch } = useAgingReport()

  useEffect(() => {
    const filters = {}
    if (projectId) filters.project_id = projectId
    fetch(filters).catch((err) => {
      if (err?.response?.status === 403) {
        toast({ variant: "destructive", title: "Error", description: "You don't have permission to view aging report." })
      }
    })
  }, [projectId])

  return (
    <div className="mx-auto max-w-[1200px]">
      <div className="mb-5 flex items-center justify-between">
        <ProjectFilter value={projectId} onChange={setProjectId} />
        <a
          href={agingExportUrl(projectId ? { project_id: projectId } : {})}
          target="_blank"
          rel="noopener noreferrer"
        >
          <Button variant="outline" size="sm" className="gap-1.5 text-[13px]">
            <Download className="h-3.5 w-3.5" />
            Export CSV
          </Button>
        </a>
      </div>

      {loading ? (
        <div className="flex items-center gap-2 p-8 text-sm text-slate-500">
          <Loader2 className="h-4 w-4 animate-spin" /> Loading…
        </div>
      ) : !data ? (
        <div className="rounded-lg border border-dashed border-slate-300 bg-white p-12 text-center">
          <p className="text-[14px] text-slate-500">No aging data available.</p>
        </div>
      ) : (
        <>
          <div className="mb-5">
            <AgingBucketChart buckets={data.buckets} />
          </div>
          <AgingTable
            byProject={data.by_project || []}
            byCustomer={data.by_customer || []}
          />
        </>
      )}
    </div>
  )
}
